import { CongratulationScreen } from '@/global/components/CongratulationScreen';
import { FC, useEffect } from 'react';

type ShopifyCompletedStepProps = {
  onInit?: VoidFunction;
  onNextStep?: VoidFunction;
  onPrevStep?: VoidFunction;
  isModal?: boolean;
};

export const ShopifyCompletedStep: FC<ShopifyCompletedStepProps> = ({ onNextStep, onPrevStep, onInit, isModal }) => {
  useEffect(() => {
    onInit?.();
  }, []);

  return (
    <CongratulationScreen
      title='data_source_edit.shopify.completed.title'
      subtitle='data_source_edit.shopify.completed.subtitle'
      primaryButton={
        isModal
          ? {
              text: 'data_source_edit.code.installation_success.choose_destination',
              onClick: onNextStep,
            }
          : {
              text: 'data_source_edit.code.installation_success.create_new_campaing',
              onClick: onNextStep,
            }
      }
      secondaryButton={
        isModal
          ? {
              text: 'data_source_edit.code.installation_success.add_another_data_source',
              onClick: onPrevStep,
            }
          : {
              text: 'data_source_edit.code.installation_success.view_all_data_sources',
              onClick: onPrevStep,
            }
      }
    />
  );
};
